import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ReactDialogBox } from "react-js-dialog-box";
import $ from "jquery";
export const HeaderHome = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [succ1, setsucc1] = useState(false);
  const [succ, setsucc] = useState(false);
  const [opendialogheader1, setopendialogheader] = useState(false);
  const [opendialogheader2, setopendialogheader2] = useState(false);
  const [valueUserDetail, setValuegetuser] = useState([]);
  const [showssheader, setshowssheader] = useState(false);
  const [showsisClickedopen, setshowsisClickedopen] = useState(true);
  const [notification1, setnotification1] = useState(false);
  const [Usernotification1, setUsernotification1] = useState([]);
  const [Usernotification1_total, setUsernotification1_total] = useState(0);
  const [SelectedFile_doc, setSelectedFile_doc] = useState([]);
  const [usersearch, setusersearch] = useState("");
  const [setSelectedFile_lic, setsetSelectedFile_lic] = useState(null);
  const [SelectedFile_docarray, setSelectedFile_docarray] = useState(null);

  const [doc1, setdoc1] = useState("");
  const [doc2, setdoc2] = useState("");
  const [doc3, setdoc3] = useState("");
  const [doc4, setdoc4] = useState("");
  const [doc5, setdoc5] = useState("");
  const handleLogout = () => {
    localStorage.removeItem("users");
    navigate("/login");
  };
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  const isMobileScreen = window.innerWidth <= 767.98;
  const [isDivVisible, setDivVisibility] = useState(!isMobileScreen);
  const [notificationsdetail, setnotificationsdetail] = useState([]);
  //useKeyboardShortcutBlocker();
  useEffect(() => {
    if (notificationsdetail) {
      const ws = new WebSocket("wss://jlmining.app");

      ws.onmessage = (event) => {
        try {
          const receivedMessage = JSON.parse(event.data);
          console.log(receivedMessage);

          if (receivedMessage.event === "AssignNewCourse") {
            refreshnot();
          }
        } catch (error) {
          console.error("Failed to parse WebSocket message:", error);
          console.error("Raw message:", event.data);
        }
      };

      ws.onopen = () => {
        console.log("WebSocket connection established");
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      return () => {
        ws.close();
        console.log("WebSocket connection closed");
      };
    }
  }, [notificationsdetail]);
  const refreshnot = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let formdata = {
      user_id: userStr[0].id,
    };
    axios
      .post("https://jlmining.app/getusernotification", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.results;
        setUsernotification1(alldata);
        var unseenCount = alldata.filter(
          (notification) => notification.status === "Unseen"
        ).length;
        setUsernotification1_total(unseenCount);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));
    const userStr = JSON.parse(localStorage.getItem("users"));

    if (userStr === null) {
      navigate("/");
    }
    const handleResize = () => {
      const isMobile = window.innerWidth <= 767.98;
      if (isMobile !== isDivVisible) {
        setDivVisibility(!isMobile);
      }
    };
    if (userStr === null) {
      setshowssheader(false);
      document.title = "Home Page";
    } else {
      setshowssheader(true);
      let formdata = {
        user_id: userStr[0].id,
      };

      axios
        .post("https://jlmining.app/admin/getuserdetails", formdata, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          var alldata = res.data.row[0];
          console.log("huuu");
          console.log(alldata);
          if (alldata === undefined || alldata === "undefined") {
            localStorage.removeItem("users");
            navigate("/login");
          }
          if (alldata.status === "Inactive") {
            navigate("/onboarding");
          }

          setValuegetuser(alldata);
        })
        .catch((err) => { });
      axios
        .post("https://jlmining.app/getusernotification", formdata, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          var alldata = res.data.results;
          setUsernotification1(alldata);
          var unseenCount = alldata.filter(
            (notification) => notification.status === "Unseen"
          ).length;
          setUsernotification1_total(unseenCount);
        })
        .catch((err) => { });
    }

    $(window).resize(handleResize);
    alterClass();
    return () => {
      $(window).off("resize", handleResize);
    };
    console.log(SelectedFile_doc);
  }, [SelectedFile_doc]);
  const handleResize = () => {
    alterClass();
  };
  const alterClass = () => {
    const ww = document.body.clientWidth;
    if (ww < 600) {
      $(".main-admin-block").addClass("close-box");
    } else if (ww >= 601) {
      $(".main-admin-block").removeClass("close-box");
    }
  };
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    contact: "",
    address: "",
  });

  const mobilepopup = () => {
    setshowsisClickedopen(!showsisClickedopen);
  };
  const fname = valueUserDetail.first_name;
  const mname = valueUserDetail.middle_name;
  const lname = valueUserDetail.last_name;
  const fLetter = fname ? fname.charAt(0) : "";
  const mLetter = mname ? mname.charAt(0) : "";
  const lLetter = lname ? lname.charAt(0) : "";
  const location = useLocation();
  const toggleDivVisibility = () => {
    setDivVisibility(!isDivVisible);
  };
  const notifica_tion = () => {
    setnotification1(!notification1);
    seeallnoti();
  };
  const closeBox = () => {
    setopendialogheader(false);
    setopendialogheader2(false);
  };
  const opendoc = () => {
    setopendialogheader(true);
  };
  const openlic = () => {
    setopendialogheader2(true);
  };
  const handleFileChange_doc1 = (event, index) => {
    const fileList = event.target.files;
    if (!fileList || fileList.length === 0) return;

    const file = fileList[0];
    if (!file) return;   // <--- prevents undefined.name error

    // Set document name
    const setters = [setdoc1, setdoc2, setdoc3, setdoc4, setdoc5];
    if (setters[index]) setters[index](file.name);

    // Update files array safely
    setSelectedFile_doc((prevFiles = []) => {
      const newFiles = [...prevFiles];
      newFiles[index] = file;
      return newFiles;     // <-- do NOT slice here
    });
  };


  const handleSubmitdoc = (event) => {
    event.preventDefault();
    console.log(SelectedFile_doc);
    const userStr = JSON.parse(localStorage.getItem("users"));
    const formDataa = new FormData();
    if (SelectedFile_doc !== null) {
      if (SelectedFile_doc.length > 0) {
        for (let i = 0; i < SelectedFile_doc.length; i++) {
          formDataa.append("files", SelectedFile_doc[i]);
        }
      }
    }

    formDataa.append("user_id", userStr[0].id);
    axios
      .post("https://jlmining.app/userUpdateDocfile", formDataa, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status === 1) {
          setsucc(true);
          event.target.reset();
          setSelectedFile_doc([]);
          setSelectedFile_docarray([]);
          setdoc1("");
          setdoc2("");
          setdoc3("");
          setdoc4("");
          setdoc5("");
          setTimeout(() => {
            setsucc(false);
          }, 2500);
        }
      })
      .catch((err) => { });
  };
  const handleFileChange_lic = (event) => {
    if (event.target.files != null) {
      const files = event.target.files;
      setsetSelectedFile_lic(event.target.files[0]);
    }
  };
  const handleSubmitlic = (event) => {
    event.preventDefault();
    const userStr = JSON.parse(localStorage.getItem("users"));
    const vl = event.target;

    const formData = new FormData();
    formData.append("name", vl.name.value);
    formData.append("user_id", userStr[0].id);
    formData.append("licence_number", vl.licence_number.value);
    formData.append("expiryMonth", vl.expiryMonth.value);
    formData.append("expiryYear", vl.expiryYear.value);
    formData.append("file", setSelectedFile_lic);
    console.log(setSelectedFile_lic);

    axios
      .post("https://jlmining.app/useruploadlic", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res.data);
        event.target.reset();
        setsucc1(true);
        setTimeout(() => {
          setsucc1(false);
        }, 2500);
      })
      .catch((err) => { });
  };
  const seeallnoti = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let formData = {
      user_id: userStr[0].id,
    };
    console.log("sddd");
    axios
      .post("https://jlmining.app/seeAllnotification", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data);
        setUsernotification1(res.data.results);
        var alldata = res.data.results;
        var unseenCount = alldata.filter(
          (notification) => notification.status === "Unseen"
        ).length;
        setUsernotification1_total(unseenCount);
      })
      .catch((err) => { });
  };
  const handleInput = (event) => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    const vl = event.target.value;
    let userse = {
      search: vl,
    };

    setusersearch(vl);
    if (vl === "") {
      const validPaths = [
        "/currentroster",
        "/timesheet",
        "/clinetinformation",
        "/ohs",
        "/site_access",
      ];
      if (location.pathname === "/home") {
        window.location.href = "/currentroster";
      } else {
        if (validPaths.includes(location.pathname)) {
          window.location.href = location.pathname;
        }
      }
    }
    localStorage.setItem("userSearch", JSON.stringify(userse));
  };
  const handlesearch = () => {
    console.log(usersearch);

    const validPaths = [
      "/currentroster",
      "/timesheet",
      "/clinetinformation",
      "/ohs",
      "/site_access",
    ];
    if (location.pathname === "/home") {
      window.location.href = "/currentroster";
    } else {
      if (validPaths.includes(location.pathname)) {
        window.location.href = location.pathname;
      }
    }
  };
  useEffect(() => {
    const storedUsername = localStorage.getItem("userSearch");
    const userSearch = storedUsername ? JSON.parse(storedUsername) : null;
    if (userSearch !== null) {
      var ss = userSearch.search;
    } else {
      var ss = "";
    }
    setusersearch(ss);
  }, [usersearch]);
  return (
    <>
      <header
        style={{ position: "relative", left: "0", right: "0" }}
        className="d-none d-sm-block"
      >
        <div
          className="navbar-top"
          style={{ display: isDivVisible ? "none" : "block" }}
        >
          <div className="d-flex flex-column">
            <div className="nav-link-main d-flex flex-column">
              <div className="navbar-list  justify-content-end d-flex flex-column">
                <Link
                  to="/home"
                  className={
                    location.pathname === "/home" ? "active fs-6" : "fs-6"
                  }
                >
                  Home
                </Link>
                {/* <Link
                  to="/profile"
                  className={
                    location.pathname === "/profile" ? "active fs-6" : "fs-6"
                  }
                >
                  Profile
                </Link> */}
                {/* <Link
                  to="/newroster"
                  className={location.pathname === "/newroster" ? "active" : ""}
                >
                  Roster
                </Link> */}
                <Link
                  to="/currentroster"
                  className={
                    location.pathname === "/currentroster"
                      ? "active fs-6"
                      : "fs-6"
                  }
                >
                  Current Roster
                </Link>
                <Link
                  to="/timesheet"
                  className={
                    location.pathname === "/timesheet" ? "active fs-6" : "fs-6"
                  }
                >
                  Signature
                </Link>
                <Link
                  to="/clinetinformation"
                  className={
                    location.pathname === "/clinetinformation"
                      ? "active fs-6"
                      : "fs-6"
                  }
                >
                  Client Info
                </Link>
                <Link
                  to="/ohs"
                  className={
                    location.pathname === "/ohs" ? "active fs-6" : "fs-6"
                  }
                >
                  OHS
                </Link>
                <Link
                  to="/site_access"
                  className={
                    location.pathname === "/site_access"
                      ? "active fs-6"
                      : "fs-6"
                  }
                >
                  Site Access
                </Link>
                <Link
                  to="/acknowledgedoc"
                  className={
                    location.pathname === "/acknowledgedoc"
                      ? "active fs-6"
                      : "fs-6"
                  }
                >
                  Send Documents
                </Link>
                <Link
                  to="/profile"
                  className={
                    location.pathname === "/profile" ? "active fs-6" : "fs-6"
                  }
                >
                  Profile
                </Link>

                <Link className="fs-6" to="/logout">
                  Logout
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container-lg">
          <div className="row gy-4 align-items-center">
            <div className="col-1">
              <div className="nav-mob">
                <button type="button" onClick={toggleDivVisibility}>
                  <i className="fal fa-bars"></i>
                </button>
              </div>
            </div>
            <div className="col-2 col-lg-2">
              <Link to="/home" className="logo-top">
                <img src={require("./assets/images/logo2.png")} alt="logo" />
              </Link>
            </div>
            <div className="col-lg-2 d-none d-lg-block">
              <Link to="/home" className="logo-top">
                <img src={require("./assets/images/hss.png")} alt="logo" />
              </Link>
            </div>
            <div className="col-9 col-lg-6 ms-auto">
              {showssheader && (
                <div className="navbar-list align-items-center  d-flex gap-3 justify-content-end">
                  <div className="input-group">
                    <input
                      required
                      onInput={handleInput}
                      value={usersearch}
                      name="searchheader"
                      type="text"
                      className="form-control"
                      placeholder="Search"
                    />
                    <button
                      onClick={handlesearch}
                      type="button"
                      className="input-group-text"
                      id="basic-addon2"
                    >
                      <i className="bi bi-search search-icon searchhomenew"></i>
                    </button>
                  </div>

                  {/* User Profile Link */}
                  <p className="user-text-icon">
                    <Link to="/profile">
                      {fLetter} {lLetter}
                    </Link>
                  </p>
                  <div
                    onClick={notifica_tion}
                    className="position-relative cursor-pointer"
                  >
                    <div className="imgcount">
                      <img
                        src={require("./assets/images/3602145.png")}
                        width="30"
                        alt="Image"
                      />
                    </div>
                    {Usernotification1_total > 0 && (
                      <span
                        className="notcount bg-danger rounded text-white text-center"
                        style={{ fontSize: "14px" }}
                      >
                        {Usernotification1_total}
                      </span>
                    )}
                    {notification1 && (
                      <>
                        {Usernotification1.length === 0 && (
                          <div className="d-flex well-info">
                            <ul style={{ height: "57px" }}>
                              {Array.isArray(Usernotification1) &&
                                Usernotification1.length > 0 ? (
                                Usernotification1.map((item, index) => (
                                  <li key={index}>
                                    <Link
                                      to={
                                        item.href_status === "course"
                                          ? "/ohs"
                                          : item.href_status === "acknowledge"
                                            ? "/acknowledgedoc"
                                            : ""
                                      }
                                    >
                                      {item.message}
                                    </Link>
                                  </li>
                                ))
                              ) : (
                                <li>No result found</li>
                              )}
                            </ul>
                            <div className="d-flex gap-3 align-items-center pb-3 px-3">
                              <div className="d-flex gap-3 align-items-center">
                                <Link
                                  to="javascript:void(0)"
                                  onClick={seeallnoti}
                                >
                                  See all Notifications
                                </Link>
                              </div>
                              <div className="d-flex flex-column gap-2 align-items-center">
                                <button type="button" onClick={opendoc}>
                                  Upload Document
                                </button>
                                <button type="button" onClick={openlic}>
                                  Upload Licence
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                        {Usernotification1.length > 0 && (
                          <div className="d-flex well-info">
                            <ul>
                              {Array.isArray(Usernotification1) &&
                                Usernotification1.length > 0 ? (
                                Usernotification1.map((item, index) => (
                                  <li key={index}>
                                    <Link
                                      to={
                                        item.href_status === "course"
                                          ? "/ohs"
                                          : item.href_status === "acknowledge"
                                            ? "/acknowledgedoc"
                                            : ""
                                      }
                                    >
                                      {item.message}
                                    </Link>
                                  </li>
                                ))
                              ) : (
                                <li>No result found</li>
                              )}
                            </ul>
                            <div className="d-flex gap-3 align-items-center pb-3 px-3">
                              <div className="d-flex gap-3 align-items-center">
                                <Link
                                  to="javascript:void(0)"
                                  onClick={seeallnoti}
                                >
                                  See all Notifications
                                </Link>
                              </div>
                              <div className="d-flex flex-column gap-2 align-items-center">
                                <button type="button" onClick={opendoc}>
                                  Upload Document
                                </button>
                                <button type="button" onClick={openlic}>
                                  Upload Licence
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  <Link className="logout" to="/logout">
                    Logout
                  </Link>
                </div>
              )}
              {!showssheader && (
                <div className="navbar-list align-items-center  d-flex gap-3 justify-content-end">
                  <Link to="/login" className="active">
                    Login
                  </Link>
                  <Link to="/register">Register</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      {/* mobile header */}
      {opendialogheader1 && (
        <ReactDialogBox
          closeBox={closeBox}
          modalWidth="60%"
          maxWidth="600px"
          headerBackgroundColor="#F60002"
          headerTextColor="white"
          headerHeight="60"
          closeButtonColor="white"
          bodyBackgroundColor="#f8fafc"
          bodyTextColor="#1e293b"
          bodyHeight="500px"
          headerText="Upload Required Documents"
          headerFontSize="18px"
          headerFontWeight="600"
        >
          <div className="modal-content-wrapper">
            <div className="document-upload-container">
              {/* Header Section */}
              <div className="upload-header">
                <div className="header-icon">
                  <i className="bi bi-file-earmark-check"></i>
                </div>
                <div className="header-content">
                  <h3 className="header-title">Document Upload Required</h3>
                  <p className="header-description">
                    You have successfully accepted the job you applied for. Please upload the documents listed below to complete your application.
                  </p>
                </div>
              </div>

              {/* Success Message */}
              {succ && (
                <div className="success-message">
                  <div className="success-icon">
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <span>All files uploaded successfully!</span>
                </div>
              )}

              <form onSubmit={handleSubmitdoc} method="post">
                <div className="document-upload-form">
                  {/* Scrollable Document Upload Sections */}
                  <div className="upload-sections-container">
                    <div className="upload-sections">
                      {/* Document 1 */}
                      <div className="upload-section">
                        <div className="section-header">
                          <span className="section-number">01</span>
                          <span className="section-label">First Document</span>
                        </div>
                        <div className="upload-controls">
                          {doc1 && (
                            <div className="file-preview">
                              <i className="bi bi-file-earmark-text"></i>
                              <span className="file-name">{doc1}</span>
                            </div>
                          )}
                          <div className="file-upload-wrapper">
                            <button type="button" className="upload-button">
                              <i className="bi bi-cloud-arrow-up"></i>
                              {doc1 ? 'Change File' : 'Upload Document'}
                            </button>
                            <input
                              type="file"
                              name="file"
                              onChange={(event) => handleFileChange_doc1(event, 0)}
                              className="file-input"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Document 2 */}
                      <div className="upload-section">
                        <div className="section-header">
                          <span className="section-number">02</span>
                          <span className="section-label">Second Document</span>
                        </div>
                        <div className="upload-controls">
                          {doc2 && (
                            <div className="file-preview">
                              <i className="bi bi-file-earmark-text"></i>
                              <span className="file-name">{doc2}</span>
                            </div>
                          )}
                          <div className="file-upload-wrapper">
                            <button type="button" className="upload-button">
                              <i className="bi bi-cloud-arrow-up"></i>
                              {doc2 ? 'Change File' : 'Upload Document'}
                            </button>
                            <input
                              type="file"
                              name="file"
                              onChange={(event) => handleFileChange_doc1(event, 1)}
                              className="file-input"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Document 3 */}
                      <div className="upload-section">
                        <div className="section-header">
                          <span className="section-number">03</span>
                          <span className="section-label">Third Document</span>
                        </div>
                        <div className="upload-controls">
                          {doc3 && (
                            <div className="file-preview">
                              <i className="bi bi-file-earmark-text"></i>
                              <span className="file-name">{doc3}</span>
                            </div>
                          )}
                          <div className="file-upload-wrapper">
                            <button type="button" className="upload-button">
                              <i className="bi bi-cloud-arrow-up"></i>
                              {doc3 ? 'Change File' : 'Upload Document'}
                            </button>
                            <input
                              type="file"
                              name="file"
                              onChange={(event) => handleFileChange_doc1(event, 2)}
                              className="file-input"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Document 4 */}
                      <div className="upload-section">
                        <div className="section-header">
                          <span className="section-number">04</span>
                          <span className="section-label">Fourth Document</span>
                        </div>
                        <div className="upload-controls">
                          {doc4 && (
                            <div className="file-preview">
                              <i className="bi bi-file-earmark-text"></i>
                              <span className="file-name">{doc4}</span>
                            </div>
                          )}
                          <div className="file-upload-wrapper">
                            <button type="button" className="upload-button">
                              <i className="bi bi-cloud-arrow-up"></i>
                              {doc4 ? 'Change File' : 'Upload Document'}
                            </button>
                            <input
                              type="file"
                              name="file"
                              onChange={(event) => handleFileChange_doc1(event, 3)}
                              className="file-input"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Document 5 */}
                      <div className="upload-section">
                        <div className="section-header">
                          <span className="section-number">05</span>
                          <span className="section-label">Fifth Document</span>
                        </div>
                        <div className="upload-controls">
                          {doc5 && (
                            <div className="file-preview">
                              <i className="bi bi-file-earmark-text"></i>
                              <span className="file-name">{doc5}</span>
                            </div>
                          )}
                          <div className="file-upload-wrapper">
                            <button type="button" className="upload-button">
                              <i className="bi bi-cloud-arrow-up"></i>
                              {doc5 ? 'Change File' : 'Upload Document'}
                            </button>
                            <input
                              type="file"
                              name="file"
                              onChange={(event) => handleFileChange_doc1(event, 4)}
                              className="file-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button - Fixed at bottom */}
                  <div className="form-actions">
                    <button type="submit" className="submit-button">
                      <i className="bi bi-send-check"></i>
                      Submit All Documents
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <style jsx>{`
      .modal-content-wrapper {
        background: #f8fafc;
        border-radius: 0 0 12px 12px;
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .document-upload-container {
        max-width: 100%;
        margin: 0 auto;
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .upload-header {
        display: flex;
        align-items: flex-start;
        gap: 16px;
        padding: 20px;
        background: white;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        margin-bottom: 16px;
        flex-shrink: 0;
      }

      .header-icon {
        background: #F60002;
        color: white;
        width: 48px;
        height: 48px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
      }

      .header-content {
        flex: 1;
      }

      .header-title {
        color: #1e293b;
        font-size: 18px;
        font-weight: 700;
        margin: 0 0 8px 0;
      }

      .header-description {
        color: #64748b;
        font-size: 14px;
        line-height: 1.5;
        margin: 0;
      }

      .success-message {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 16px;
        background: #dcfce7;
        border: 1px solid #22c55e;
        border-radius: 8px;
        margin-bottom: 16px;
        color: #166534;
        font-weight: 500;
        flex-shrink: 0;
      }

      .success-icon {
        color: #22c55e;
        font-size: 16px;
      }

      .document-upload-form {
        background: white;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        height:350px;
        overflow:scroll;
      }

      .upload-sections-container {
        flex: 1;
        overflow-y: auto;
        margin-bottom: 20px;
        min-height: 0;
      }

      .upload-sections {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      .upload-section {
        padding: 18px;
        border: 2px solid #f1f5f9;
        border-radius: 12px;
        transition: all 0.2s ease;
        background: white;
      }

      .upload-section:hover {
        border-color: #F60002;
        background: #fef2f2;
      }

      .section-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 14px;
      }

      .section-number {
        background: #F60002;
        color: white;
        width: 32px;
        height: 32px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 700;
      }

      .section-label {
        color: #1e293b;
        font-size: 15px;
        font-weight: 600;
      }

      .upload-controls {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
      }

      .file-preview {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        background: #f1f5f9;
        border-radius: 8px;
        color: #475569;
        font-size: 14px;
        flex: 1;
        min-width: 200px;
      }

      .file-preview i {
        color: #F60002;
      }

      .file-name {
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .file-upload-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
      }

      .upload-button {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        background: #F60002;
        color: white;
        border: none;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
      }

      .upload-button:hover {
        background: #d40002;
        transform: translateY(-1px);
      }

      .file-input {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      .form-actions {
        display: flex;
        justify-content: center;
        border-top: 1px solid #f1f5f9;
        
        margin-top: auto;
        flex-shrink: 0;
      }

      .submit-button {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 14px 32px;
        background: #F60002;
        color: white;
        border: none;
        border-radius: 8px;
        font-weight: 600;
        font-size: 15px;
        cursor: pointer;
        transition: all 0.2s ease;
        min-width: 200px;
        justify-content: center;
      }

      .submit-button:hover {
        background: #d40002;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(246, 0, 2, 0.3);
      }

      /* Custom scrollbar styling */
      .upload-sections-container::-webkit-scrollbar {
        width: 6px;
      }

      .upload-sections-container::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 3px;
      }

      .upload-sections-container::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 3px;
      }

      .upload-sections-container::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
      }

      @media (max-width: 768px) {
        .modal-content-wrapper {
          padding: 16px;
        }
        
        .upload-header {
          flex-direction: column;
          text-align: center;
          padding: 16px;
        }
        
        .upload-controls {
          flex-direction: column;
          align-items: stretch;
        }
        
        .file-preview {
          min-width: auto;
        }
        
        .upload-button {
          width: 100%;
          justify-content: center;
        }
        
        .submit-button {
          width: 100%;
        }

        .document-upload-form {
          padding: 16px;
        }
      }

      @media (max-width: 480px) {
        .upload-section {
          padding: 14px;
        }
        
        .upload-sections {
          gap: 12px;
        }
      }
    `}</style>
        </ReactDialogBox>
      )}
      {opendialogheader2 && (
        <ReactDialogBox
          closeBox={closeBox}
          modalWidth="60%"
          maxWidth="500px"
          headerBackgroundColor="#F60002"
          headerTextColor="white"
          headerHeight="60"
          closeButtonColor="white"
          bodyBackgroundColor="#f8fafc"
          bodyTextColor="#1e293b"
          bodyHeight="auto"
          bodyMinHeight="400px"
          headerText="Upload License Document"
          headerFontSize="18px"
          headerFontWeight="600"
        >
          <div className="modal-content-wrapper" style={{ padding: '20px' }}>
            <form onSubmit={handleSubmitlic} method="post" className="license-upload-form">
              <div className="form-container">
                {/* Success Message */}
                {succ1 && (
                  <div className="success-message">
                    <div className="success-icon">
                      <i className="bi bi-check-circle-fill"></i>
                    </div>
                    <span>License file uploaded successfully!</span>
                  </div>
                )}

                {/* Form Fields */}
                <div className="form-field-group">
                  <div className="form-field">
                    <label className="form-label">
                      License Name <span className="required-asterisk">*</span>
                    </label>
                    <input
                      className="form-input"
                      type="text"
                      required
                      name="licence_number"
                      placeholder="Enter license name"
                    />
                  </div>

                  <div className="form-field">
                    <label className="form-label">
                      Your Name <span className="required-asterisk">*</span>
                    </label>
                    <input
                      className="form-input"
                      type="text"
                      name="name"
                      required
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div className="form-field">
                    <label className="form-label">
                      Expiry Date <span className="required-asterisk">*</span>
                    </label>
                    <div className="date-input-group">
                      <div className="date-field">
                        <input
                          required
                          className="date-input"
                          type="text"
                          placeholder="MM"
                          name="expiryMonth"
                          pattern="[0-9]*"
                          min="1"
                          maxLength="2"
                        />
                        <span className="date-label">Month</span>
                      </div>
                      <div className="date-separator">/</div>
                      <div className="date-field">
                        <input
                          required
                          className="date-input"
                          type="text"
                          placeholder="YYYY"
                          pattern="[0-9]*"
                          min="1"
                          maxLength="4"
                          name="expiryYear"
                        />
                        <span className="date-label">Year</span>
                      </div>
                    </div>
                  </div>

                  <div className="form-field">
                    <label className="form-label">
                      License File <span className="required-asterisk">*</span>
                    </label>
                    <div className="file-upload-container">
                      <div className="file-upload-wrapper">
                        <button type="button" className="file-upload-button">
                          <i className="bi bi-cloud-upload"></i>
                          Choose File
                        </button>
                        <input
                          type="file"
                          name="file"
                          onChange={handleFileChange_lic}
                          required
                          className="file-input"
                          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        />
                        <span className="file-hint">PDF, DOC, JPG, PNG (Max 10MB)</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="form-actions">
                  <button type="submit" className="submit-button">
                    <i className="bi bi-check-lg"></i>
                    Upload License
                  </button>
                </div>
              </div>
            </form>
          </div>

          <style jsx>{`
      .modal-content-wrapper {
        background: #f8fafc;
        border-radius: 0 0 12px 12px;
      }

      .form-container {
        max-width: 100%;
        margin: 0 auto;
      }

      .success-message {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 16px;
        background: #dcfce7;
        border: 1px solid #22c55e;
        border-radius: 8px;
        margin-bottom: 20px;
        color: #166534;
        font-weight: 500;
      }

      .success-icon {
        color: #22c55e;
        font-size: 16px;
      }

      .form-field-group {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-bottom: 30px;
      }

      .form-field {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .form-label {
        font-weight: 600;
        color: #374151;
        font-size: 14px;
        margin-bottom: 4px;
      }

      .required-asterisk {
        color: #ef4444;
      }

      .form-input {
        padding: 12px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        font-size: 14px;
        transition: all 0.2s ease;
        background: white;
      }

      .form-input:focus {
        outline: none;
        border-color: #F60002;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
      }

      .form-input::placeholder {
        color: #9ca3af;
      }

      .date-input-group {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .date-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1;
      }

      .date-input {
        padding: 12px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        transition: all 0.2s ease;
        background: white;
      }

      .date-input:focus {
        outline: none;
        border-color: #F60002;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
      }

      .date-label {
        font-size: 11px;
        color: #6b7280;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .date-separator {
        color: #6b7280;
        font-weight: 600;
        font-size: 18px;
        margin-top: 12px;
      }

      .file-upload-container {
        margin-top: 4px;
      }

      .file-upload-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
        width: 100%;
      }

      .file-upload-button {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 20px;
        background: #F60002;
        color: white;
        border: none;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        width: 100%;
        justify-content: center;
      }

      .file-upload-button:hover {
        background: #1d4ed8;
        transform: translateY(-1px);
      }

      .file-input {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      .file-hint {
        display: block;
        margin-top: 6px;
        font-size: 12px;
        color: #6b7280;
        text-align: center;
      }

      .form-actions {
        display: flex;
        justify-content: center;
        margin-top: 10px;
      }

      .submit-button {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 14px 32px;
        background: #059669;
        color: white;
        border: none;
        border-radius: 8px;
        font-weight: 600;
        font-size: 15px;
        cursor: pointer;
        transition: all 0.2s ease;
        min-width: 160px;
        justify-content: center;
      }

      .submit-button:hover {
        background: #047857;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
      }

      @media (max-width: 480px) {
        .modal-content-wrapper {
          padding: 16px;
        }
        
        .date-input-group {
          gap: 8px;
        }
        
        .submit-button {
          width: 100%;
        }
      }
    `}</style>
        </ReactDialogBox>
      )}

      <header
        style={{ position: "relative", left: "0", right: "0" }}
        className="d-block d-sm-none "
      >
        <div
          className="navbar-top"
          style={{ display: isDivVisible ? "block" : "none" }}
        >
          <div className="d-flex flex-column">
            <div className="nav-link-main d-flex flex-column">
              <div className="navbar-list  justify-content-end d-flex flex-column">
                <Link
                  to="/home"
                  className={
                    location.pathname === "/home" ? "active fs-6" : "fs-6"
                  }
                >
                  Home
                </Link>
                {/* <Link
                  to="/profile"
                  className={
                    location.pathname === "/profile" ? "active fs-6" : "fs-6"
                  }
                >
                  Profile
                </Link> */}
                {/* <Link
                  to="/newroster"
                  className={location.pathname === "/newroster" ? "active" : ""}
                >
                  Roster
                </Link> */}
                <Link
                  to="/currentroster"
                  className={
                    location.pathname === "/currentroster"
                      ? "active fs-6"
                      : "fs-6"
                  }
                >
                  Current Roster
                </Link>
                {/* <Link
                  to="/timesheet"
                  className={
                    location.pathname === "/timesheet" ? "active fs-6" : "fs-6"
                  }
                >
                  Signature
                </Link> */}
                <Link
                  to="/clinetinformation"
                  className={
                    location.pathname === "/clinetinformation"
                      ? "active fs-6"
                      : "fs-6"
                  }
                >
                  Client Info
                </Link>
                <Link
                  to="/ohs"
                  className={
                    location.pathname === "/ohs" ? "active fs-6" : "fs-6"
                  }
                >
                  OHS
                </Link>
                <Link
                  to="/site_access"
                  className={
                    location.pathname === "/site_access"
                      ? "active fs-6"
                      : "fs-6"
                  }
                >
                  Site Access
                </Link>
                <Link
                  to="/acknowledgedoc"
                  className={
                    location.pathname === "/acknowledgedoc"
                      ? "active fs-6"
                      : "fs-6"
                  }
                >
                  Acknowledge Documents
                </Link>
                <Link
                  to="/profile"
                  className={
                    location.pathname === "/profile" ? "active fs-6" : "fs-6"
                  }
                >
                  Profile
                </Link>

                <Link className="fs-6" to="/logout">
                  Logout
                </Link>
              </div>
            </div>
          </div>
        </div>
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
          <div class="container-fluid">
            <div className="d-flex flex-column gap-3 w-100">
              <div class="d-flex justify-content-between w-100  gap-3  align-items-center ps-2">
                <div className="nav-mob">
                  <button type="button" onClick={toggleDivVisibility}>
                    <i className="fal fa-bars"></i>
                  </button>
                </div>
                <Link to="#" className="logo-top ">
                  <img src={require("./assets/images/logo2.png")} alt="logo" />
                </Link>
                <Link to="#" className="logo-top ">
                  <img src={require("./assets/images/hss.png")} alt="logo" />
                </Link>
                <div
                  onClick={notifica_tion}
                  className="position-relative cursor-pointer"
                >
                  <img
                    src={require("./assets/images/3602145.png")}
                    width="30"
                    alt="Image"
                  />
                  {notification1 && (
                    <>
                      {Usernotification1.length === 0 && (
                        <div className="d-flex well-info">
                          <ul style={{ height: "57px" }}>
                            {Array.isArray(Usernotification1) &&
                              Usernotification1.length > 0 ? (
                              Usernotification1.map((item, index) => (
                                <li key={index}>
                                  <Link>{item.message}</Link>
                                </li>
                              ))
                            ) : (
                              <li>No data available</li>
                            )}
                          </ul>
                          <div className="d-flex gap-3 align-items-center pb-3 px-3">
                            <div className="d-flex gap-3 align-items-center">
                              <Link
                                to="javascript:void(0)"
                                onClick={seeallnoti}
                              >
                                See all Notifications
                              </Link>
                            </div>
                            <div className="d-flex flex-column gap-2 align-items-center">
                              <button type="button" onClick={opendoc}>
                                Upload Document
                              </button>
                              <button type="button" onClick={openlic}>
                                Upload Licence
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {Usernotification1.length > 0 && (
                        <div className="d-flex well-info">
                          <ul>
                            {Array.isArray(Usernotification1) &&
                              Usernotification1.length > 0 ? (
                              Usernotification1.map((item, index) => (
                                <li key={index}>
                                  <Link>{item.message}</Link>
                                </li>
                              ))
                            ) : (
                              <li>No data available</li>
                            )}
                          </ul>
                          <div className="d-flex gap-3 align-items-center pb-3 px-3">
                            <div className="d-flex gap-3 align-items-center">
                              <Link>See all Notifications</Link>
                            </div>
                            <div className="d-flex flex-column gap-2 align-items-center">
                              <button type="button" onClick={opendoc}>
                                Upload Document
                              </button>
                              <button type="button" onClick={openlic}>
                                Upload Licence
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className=" d-block">
                  <div className="navbar-list float-end">
                    <p className="user-text-icon">
                      <Link to="/profile">
                        {fLetter} {mLetter} {lLetter}
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="What work are you looking for today?"
                />
                <span className="input-group-text" id="basic-addon2">
                  <i className="bi bi-search search-icon searchhomenew"></i>
                </span>
              </div>
            </div>
          </div>
        </nav>
        {/*
        <div className="container-lg">
          <div className="row gy-3 align-items-center justify-content-between">
            <div className="col-4">
              <Link to="#" className="logo-top">
                <img src={require("./assets/images/logo2.png")} alt="logo" />
              </Link>
            </div>
            <div className="col-4">
              <Link to="#" className="logo-top">
                <img src={require("./assets/images/logo2.png")} alt="logo" />
              </Link>
            </div>

            <div className="col-8"></div>
            <div className="col-12"></div>
          </div>
        </div> */}
      </header>
    </>
  );
};
